import { FC, useState } from 'react';
import { Box, Dialog, DialogTitle, Grid, Stack } from '@mui/material';
import { NodeObject } from 'react-force-graph-2d';
// eslint-disable-next-line import/no-cycle
import { Icon } from '@iconify/react';
// eslint-disable-next-line import/no-cycle
import { NodesList } from '../NodesList';
// eslint-disable-next-line import/no-cycle
import { NodeType } from '../NodeContextMenu';

interface AddNodeProps {
  title: string;
  nodeName: string;
  nodes: NodeObject[];
  open: boolean;
  chosenNode: (source: string, target: string, type: NodeType) => void;
  onClose: () => void;
}

export const AddNode: FC<AddNodeProps> = ({
  title,
  nodes,
  open,
  nodeName,
  chosenNode,
  onClose,
}) => {
  const handleClose = () => {
    onClose();
  };

  const [showEnterButton, setShowEnterButton] = useState<boolean>(false);

  return (
    <Dialog onClose={handleClose} open={open}>
      <Stack
        direction={'row'}
        alignItems={'center'}
        sx={{ pl: nodeName?.length === 0 ? 2 : 0 }}
      >
        {nodeName?.length === 0 && (
          <Icon icon="bi:node-plus-fill" fontSize={35} color={'#ababab'} />
        )}
        <DialogTitle sx={{ maxWidth: '90%' }}>{title}</DialogTitle>
        {showEnterButton && (
          <Grid container sx={{ pr: 2 }}>
            <Box sx={{ flexGrow: 1 }} />
            <Icon
              icon="icon-park-twotone:enter-key"
              color={'gray'}
              fontSize={35}
            />
          </Grid>
        )}
      </Stack>
      <NodesList
        nodes={nodes}
        onQueryChange={(q) => {
          setShowEnterButton(q?.length > 0);
        }}
        chosenNode={(id, type) => {
          chosenNode(nodeName, id, type);
          handleClose();
        }}
      />
    </Dialog>
  );
};
